<template>
  <div id="businessList">
    <div class="container">
      <!-- <el-button type="success" v-if="tableData.length==1" @click="addNew()">添加</el-button> -->
      <el-table
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <el-table-column prop="name" label="公司名称"></el-table-column>
        <el-table-column prop="address" label="公司地址" width="290px"></el-table-column>
        <el-table-column prop="phone" label="公司电话"></el-table-column>
        <el-table-column prop="faxes" label="传真"></el-table-column>
        <el-table-column prop="email" label="公司邮箱"></el-table-column>
        <el-table-column prop="officialWeb" label="公司官网"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="addNew(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>

 <el-dialog
      :title="isEdit?'编辑公司信息':'新增公司信息'"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose"
      v-if="dialogVisible"
    >
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="110px"
        class="demo-ruleForm"
      >
      <el-form-item label="公司名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="address">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item>
        <el-form-item label="公司电话" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="传真" prop="faxes">
          <el-input v-model="ruleForm.faxes"></el-input>
        </el-form-item>
        <el-form-item label="公司邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="公司官网" prop="officialWeb">
          <el-input v-model="ruleForm.officialWeb"></el-input>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAdd()">取 消</el-button>
          <el-button type="primary"  @click="confirmAdd">确 定</el-button>
        </span>
       </el-dialog>
      
    </div>
  </div>
</template>

<script>
import { getCompanyInfo, addCompanyInfo, editCompanyInfo } from "@/api/manage";
export default {
  data() {
    return {
      tableData:[],
      isEdit:false,
      editId:'',
      dialogVisible:false,
      ruleForm:{
        name:'',
        address:'',
        phone:'',
        faxes:'',
        email:'',
        officialWeb:''
      },
      rules:{
         name: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "请输入公司地址",
            trigger: ["blur", "change"],
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入公司电话",
            trigger: ["blur", "change"],
          },
        ],
        faxes: [
          {
            required: true,
            message: "请输入传真",
            trigger: ["blur", "change"],
          },
        ],
        email: [
          {
            required: true,
            message: "请输入公司邮箱",
            trigger: ["blur", "change"],
          },
        ],
        officialWeb: [
          {
            required: true,
            message: "请输入公司官网",
            trigger: ["blur", "change"],
          },
        ],
      }
    };
  },
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    async getData() {
      //获取公司信息
      let res = await getCompanyInfo();
      this.tableData=[res.data]
    },
    handleSelectionChange(val) {
    },
    addNew(data) {
      //新增或编辑
      this.isEdit = data ? true : false;
      this.editId=data ? data.id : '';
      this.dialogVisible = true;
      this.ruleForm.name = data ? data.name : "";
      this.ruleForm.address = data ? data.address : "";
      this.ruleForm.phone = data ? data.phone : "";
      this.ruleForm.faxes = data ? data.faxes : "";
      this.ruleForm.email = data ? data.email : "";
      this.ruleForm.officialWeb = data ? data.officialWeb : "";
    },
    handleClose(done) {
      //弹窗关闭前的钩子
      this.$refs["ruleForm"].resetFields();
      done();
    },
    cancelAdd() {
      //取消添加
      this.dialogVisible = false;
      this.$refs["ruleForm"].resetFields();
    },
    confirmAdd() {
      //确认新增公司信息,确认编辑公司信息
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          if (!this.isEdit) {
            //判断当前是否为编辑状态
            let res = await addCompanyInfo(this.ruleForm);
            if (res.code == 200) {
              this.dialogVisible = false;
              this.$message.success("新增公司信息成功！");
              this.$refs["ruleForm"].resetFields();
            }
          } else if (this.isEdit) {
            let param = JSON.parse(JSON.stringify(this.ruleForm));
            param.id = this.editId;
            let res = await editCompanyInfo(param);
            if (res.code == 200) {
              this.dialogVisible = false;
              this.$message.success("编辑公司信息成功！");
              this.$refs["ruleForm"].resetFields();
            }
          }
          this.getData();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#businessList {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.red {
  color: #f56c6c;
}
</style>